import React, {
  useMemo,
} from 'react'

import PropTypes from 'prop-types'
import classnames from 'classnames'

import Styles from './styles.module.sass'

/**
 * This component will fill the height of its container.
 *
 * @returns {Node}
 */
export default function Loading({ className, circleColor }) {
  const rootClassName = classnames(Styles.root, className)

  const style = useMemo(() => ({
    '--loading-circle-color': circleColor,
  }), [circleColor])

  return (
    <div
      className={ rootClassName }
      style={ style }
    >
      <svg
        className={ Styles.spinner }
        viewBox="0 0 50 50"
      >
        <circle
          className={ Styles.path }
          cx="25"
          cy="25"
          r="23.5"
          fill="none"
          strokeWidth="3"
        >
        </circle>
      </svg>
    </div>
  )
}

Loading.propTypes = {
  className: PropTypes.string,
  /**
   * Any valid HTML color string
   */
  circleColor: PropTypes.string,
}
